(function () {
  var CFG = {
    variante: 59070706974984,
    precio: 5400,
    titulo: 'Envío seguro',
    texto: 'Si tu pedido se pierde o llega dañado, te lo reenviamos gratis.'
  };

  var css = document.createElement('style');
  css.textContent =
    '.vit-envio{display:flex;align-items:center;gap:12px;margin:0 0 12px;padding:12px 14px;border:1.5px solid #EADFDD;border-radius:12px;background:#fff;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.vit-envio.is-on{border-color:#92130A;background:#FBEDEB}' +
    '.vit-envio input{position:absolute;opacity:0;width:1px;height:1px}' +
    '.vit-envio__check{flex:0 0 22px;width:22px;height:22px;border:2px solid #B9A9A6;border-radius:6px;display:grid;place-items:center;background:#fff;transition:background-color .15s,border-color .15s}' +
    '.vit-envio__check svg{width:14px;height:14px;fill:none;stroke:#fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;opacity:0}' +
    '.vit-envio.is-on .vit-envio__check{background:#92130A;border-color:#92130A}' +
    '.vit-envio.is-on .vit-envio__check svg{opacity:1}' +
    '.vit-envio input:focus-visible+.vit-envio__check{outline:2px solid #92130A;outline-offset:2px}' +
    '.vit-envio__ico{flex:0 0 auto;width:26px;height:26px;fill:none;stroke:#92130A;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}' +
    '.vit-envio__txt{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}' +
    '.vit-envio__t{font-size:14px;font-weight:800;color:#121212}' +
    '.vit-envio__d{font-size:12px;line-height:1.4;color:#5A5555}' +
    '.vit-envio__p{flex:0 0 auto;font-size:14px;font-weight:800;color:#121212}' +
    '.vit-envio[aria-busy="true"]{opacity:.6;pointer-events:none}';
  document.head.appendChild(css);

  function base() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function cfg(t) {
    return typeof fetchConfig === 'function' ? fetchConfig(t) : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
  }
  function money(el, c) {
    if (el && typeof el.money === 'function') return el.money(c);
    return '$' + (c / 100).toFixed(2);
  }

  async function cambiar(el, activar) {
    var caja = el.querySelector('.vit-envio');
    if (caja) caja.setAttribute('aria-busy', 'true');
    try {
      if (activar) {
        await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', Object.assign({}, cfg('javascript'), { body: JSON.stringify({ items: [{ id: CFG.variante, quantity: 1 }] }) }));
      } else {
        var u = {};
        ((el.cart && el.cart.items) || []).forEach(function (it) { if (it.variant_id === CFG.variante) u[it.key] = 0; });
        if (Object.keys(u).length) await fetch(base() + '/update.js', Object.assign({}, cfg('json'), { body: JSON.stringify({ updates: u }) }));
      }
    } catch (e) {}
    if (typeof el.refrescar === 'function') await el.refrescar();
  }

  function decorar(el) {
    var c = el.cart;
    if (!c) return;
    var items = c.items || [];
    var prot = items.find(function (it) { return it.variant_id === CFG.variante; });
    var otros = items.filter(function (it) { return it.variant_id !== CFG.variante && !(it.properties && it.properties._regalo); });

    if (prot) {
      var li = el.querySelector('[data-lista] [data-key="' + prot.key + '"]');
      if (li) li.remove();
    }
    if (prot && (!otros.length || prot.quantity !== 1) && !el.__vitEnvioArreglando) {
      el.__vitEnvioArreglando = true;
      var u = {}; u[prot.key] = otros.length ? 1 : 0;
      fetch(base() + '/update.js', Object.assign({}, cfg('json'), { body: JSON.stringify({ updates: u }) })).then(function () { return el.refrescar && el.refrescar(); }).finally(function () { el.__vitEnvioArreglando = false; });
      return;
    }

    var pie = el.querySelector('[data-pie]');
    if (!pie) return;
    var caja = pie.querySelector('.vit-envio');
    if (!otros.length) { if (caja) caja.remove(); return; }
    if (!caja) {
      caja = document.createElement('label');
      caja.className = 'vit-envio';
      caja.innerHTML =
        '<input type="checkbox">' +
        '<span class="vit-envio__check" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
        '<svg class="vit-envio__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5.5c0 4.3-3 7.9-7 9.5-4-1.6-7-5.2-7-9.5V6l7-3z"/><path d="M9 12l2.2 2.2L15.5 10"/></svg>' +
        '<span class="vit-envio__txt"><span class="vit-envio__t"></span><span class="vit-envio__d"></span></span>' +
        '<span class="vit-envio__p"></span>';
      caja.querySelector('.vit-envio__t').textContent = CFG.titulo;
      caja.querySelector('.vit-envio__d').textContent = CFG.texto;
      caja.querySelector('input').addEventListener('change', function (e) { cambiar(el, e.target.checked); });
      pie.insertBefore(caja, pie.firstChild);
    }
    var on = !!prot;
    caja.querySelector('input').checked = on;
    caja.classList.toggle('is-on', on);
    caja.removeAttribute('aria-busy');
    caja.querySelector('.vit-envio__p').textContent = '+' + money(el, prot ? prot.final_line_price : CFG.precio);
  }

  function parchear() {
    var C = customElements.get('vitalce-carrito');
    if (!C || C.prototype.__vitEnvio) return;
    C.prototype.__vitEnvio = true;
    var original = C.prototype.pintar;
    C.prototype.pintar = async function () {
      await original.call(this);
      decorar(this);
    };
    var el = document.querySelector('vitalce-carrito');
    if (el && el.cart) decorar(el);
  }

  if (customElements.get('vitalce-carrito')) parchear();
  else customElements.whenDefined('vitalce-carrito').then(parchear);
})();
